<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Products'"></navbar>
			<!--导航-->
			<!--banner-->
			<!-- <div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/01顶部banner@2x.webp" class="bg" />
				<div class="msg_box">
					<div class="tit">CorDx Products</div>
					<div class="txt">
						CorDx ensures a reliable supply of accurate, easy-to-use diagnostics products priced for all.
					</div>
				</div>
			</div> -->
			<!--banner-->
			<!--块1-->
			<div class="block_0"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">CorDx Products</div>
				<div class="txt">
					CorDx develops diagnostic tests that medical professionals and families trust – then brings them to OTC and POC markets at scale through our own procurement, production and logistics processes. 
				</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"	
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/20230912-084352.webp" />
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_box">
					<div class="tit">
						Healthcare providers, request your free sample kit today:<br />CorDx Tyfast Flu A/B & COVID-19 Multiplex Test
					</div>
					<div class="btn_box_more btn_box" @click="goProduct7">
						Learn More
					</div>
				</div>
			</div>
			<!--块1-->
			<!--引导块-->
			<div v-if="isCateProduct" class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ cateName }}
			</div>
			<!--引导块-->
			<!--块2-->
			<div class="block_2">
				<div class="left"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-loading="cateLoading" class="cate_box">
						<div class="tit">Categories</div>
						<div class="list_box">
							<div v-for="(value, index) in cateOptions" :key="index" class="list_el" @click="cateHandle(value)">
								<div class="list_el_main">
									<div class="left">
										<img :src="value.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
									</div>
									<div class="right">
										{{ value.catname }}
									</div>
								</div>
								<template v-if="value.children.length > 0">
									<div v-for="(value1, index1) in value.children" :key="index1" class="list_el_child" @click.stop="cateHandle(value1)">
										<div class="list_el_main">
											<div class="left">
												<img :src="value1.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
											</div>
											<div class="right">
												{{ value1.catname }}
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="cate_box">
						<div class="tit">Product certifications</div>
						<div class="search_box">
							<input v-model="rzVal" placeholder="Search..." v-on:input="rzInput" />
						</div>
						<div class="list_box list_height">
							<div v-for="(value, index) in rzOptions" :key="index" class="list_el" @click="authHandle(1, value)">
								<div class="list_el_main">
									<div class="left">
										<img :src="value.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
									</div>
									<div class="right">
										{{ value.catname }}
									</div>
								</div>
								<template v-if="value.children.length > 0">
									<div v-for="(value1, index1) in value.children" :key="index1" class="list_el_child" @click.stop="authHandle(2, value1)">
										<div class="list_el_main">
											<div class="left">
												<img :src="value1.is_checked == 1 ? require('@/assets/img/checked.png') : require('@/assets/img/no_check.png') " />
											</div>
											<div class="right">
												{{ value1.catname }}
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="input_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<input v-model="searchVal" placeholder="Search Product" v-on:input="searchInput" />
						<div class="btn_box" @click="searchProduct">
							<van-icon name="search" size="20px" color="#ffffff" style="position: relative;top: 3px;font-weight: bold;" />
						</div>
					</div>
					<div v-if="searchData.length > 0" v-loading="searchLoading" class="search_list">
						<div>
							<div class="top_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="top_box_left">{{ searchPage }} Results</div>
								<div class="top_box_right">
									<van-pagination
										v-model="seatchCurrentPage"
										:items-per-page="5"
										:total-items="searchPage"
										mode="simple"
										@change="searchPageChange"
									>
										<template #prev-text>
											<van-icon name="arrow-left" />
										</template>
										<template #next-text>
											<van-icon name="arrow" />
										</template>
									</van-pagination>
								</div>
							</div>
							<div class="search_list_main">
								<div v-for="(value, index) in searchData" :key="index" class="search_el"
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									@click="goProductInfo(value)"
								>
									<div class="search_el_left">
										<img :src="value.url" />
									</div>
									<div class="search_el_right">
										<div class="title">{{ value.title }}</div>
										<div class="text">{{ value.description }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<template v-else>
						<div v-if="searchVal != ''" class="search_list">
							<div style="padding: 20px 0;color: #999999;text-align: center;">
								<!-- Sorry, but nothing matched your search terms. -->
								<img src="../../assets/img/search_no.png" />
							</div>
						</div>
					</template>
					<div v-if="productType.length > 0" class="tags"
						data-aos="fade-left"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div :class="nowTest == 'All' ? 'actived' : ''" @click="testHandle('All')">All</div>
						<div v-for="(value, index) in productType" :key="index" :class="nowTest == value.id ? 'actived' : ''" @click="testHandle(value.id)">{{ value.catname }}</div>
					</div>
					<div class="product_main"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-if="productData.length > 0" v-loading="productLoading" class="product_list">
							<div v-for="(value, index) in productData" :key="index" class="product_el" @click="goProductInfo(value)">				
								<div class="bg_box">
									<img class="bg" :src="value.url" />
								</div>
								<div class="tit_box">
									<div class="tit">{{ value.title }}</div>
									<div class="icon">
										<img src="../../assets/img/组 32@2x.png" />
									</div>
								</div>
								<div class="txt">{{ value.description }}</div>
							</div>
						</div>
						<div v-else style="padding: 20px 0;color: #999999;text-align: center;">
							<!-- Sorry, but nothing matched your search terms. -->
							<img src="../../assets/img/search_no.png" />
						</div>
						
					</div>
					<div v-if="productData.length > 0" class="page_box">
						<el-pagination
							layout="prev, pager, next"
							:total="productPage"
							:page-size="6"
							@current-change="productPageChange"
						></el-pagination>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { productCate, productCates, productAuth, productList, productSearch, productTest, } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			cateOptions: [],  //产品分类数据
			cateLoading: false,
			rzOptions: [],  //产品认证数据
			rzVal: '',  //产品认证搜索
			searchVal: '',  //产品搜索
			seatchCurrentPage: 1,  //产品搜索翻页
			isCateProduct: null,  //是否展示产品分类
			cateName: '',  //产品分类名
			cateIds: [],
			authIds: [],
			productData: [],
			productPage: 0,
			noPage1: 1,
			productLoading: false,
			searchData: [],
			searchPage: 0,
			noPage2: 1,
			searchLoading: false,
			nowTest: 'All',
			productType: [],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Products - CorDx';
		
		// console.log(that.$route.params.cateId);
		// return false;
		if(that.$route.params.cateId != 'all') {
			that.isCateProduct = true;
			that.cateIds = [that.$route.params.cateId];
			that.getProductCates(that.$route.params.cateId);  //请求产品分类
			//that.getProductList();  //请求产品列表
		}else {
			that.isCateProduct = false;
			that.getProductCates('');  //请求产品分类
			//that.getProductList();  //请求产品列表
		}
		that.getProductAuth('');  //请求产品认证
		// document.title = 'Products - CorDx';
		// if(that.$route.query.type) {
		// 	that.isCateProduct = true;
		// 	that.cateIds = [that.$route.query.type];
		// 	that.getProductCate(that.$route.query.type);  //请求产品分类
		// 	//that.getProductList();  //请求产品列表
		// }else {
		// 	that.isCateProduct = false;
		// 	that.getProductCates('');  //请求产品分类
		// 	//that.getProductList();  //请求产品列表
		// }
		// that.getProductAuth('');  //请求产品认证
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//查询产品检测类型
		getProductTest() {
			let that = this;
			that.productType = [];
			that.nowTest = 'All';
			productTest({ custom: that.cateIds.join(','), language: sessionStorage.getItem('lang'), }).then(res => {
				that.productType = res.data;
			});
		},
		//检测途径点击
		testHandle(value) {
			let that = this;
			that.nowTest = value;
			that.noPage1 = 1;
			that.getProductList();
		},
		//产品输入搜索
		searchInput() {
			let that = this;
			if(that.searchVal != '') {
				that.noPage2 = 1;
				that.searchProductList();
			}else {
				that.noPage2 = 1;
				that.searchData = [];
				that.searchPage = 0;
			}
		},
		//产品搜索翻页
		searchPageChange(val) {
			let that = this;
			that.noPage2 = val;
			that.searchProductList();
		},
		//点击搜索产品
		searchProduct() {
			let that = this;
			if(that.searchVal != '') {
				that.noPage2 = 1;
				that.searchProductList();
			}else {
				that.noPage2 = 1;
				that.searchData = [];
				that.searchPage = 0;
			}
		},
		//产品搜索
		searchProductList() {
			let that = this;
			that.searchLoading = true;
			productSearch({
				keyword: that.searchVal,
				page: that.noPage2,
				page_size: 5,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.searchData = res.data.data;
				that.searchPage = res.data.total;
				that.searchLoading = false;
			});
		},
		//点击查看产品详情
		goProductInfo(value) {
			let that = this; // flu-a%2Fb-&-covid-19-multiplex-rapid-test cordx-tyfast-flu-a/b-&-covid-19-multiplex-rapid-test
			if(value.custom == 'flu-a/b-&-covid-19-multiplex-rapid-test') {
				let routeData1 = that.$router.resolve({name: "Productsinfos", params: { productInfoIds: value.custom } });
				window.open(routeData1.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-at-home-rapid-multiplex-test-cordx') {
				let routeData2 = that.$router.resolve({name: "Productsinfos2", params: { productInfoIds: value.custom } });
				window.open(routeData2.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-covid-19-ag-rapid-test') {
				let routeData3 = that.$router.resolve({name: "Productsinfos3", params: { productInfoIds: value.custom } });
				window.open(routeData3.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-multi-drug-rapid-test-cup') {
				let routeData4 = that.$router.resolve({name: "cordx-tyfast-multi-drug-rapid-test-cup" });
				window.open(routeData4.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-rsv-rapid-test') {
				let routeData5 = that.$router.resolve({name: "cordx-tyfast-rsv-rapid-test" });
				window.open(routeData5.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-ovulation-test-pregnancy-test-combo') {
				let routeData7 = that.$router.resolve({name: "cordx-tyfast-ovulation-test-pregnancy-test-combo" });
				window.open(routeData7.href, '_blank');
			}else if(value.custom == 'cordx-one-step-hcg-pregnancy-test-cassette') {
				let routeData8 = that.$router.resolve({name: "cordx-one-step-hcg-pregnancy-test-cassette" });
				window.open(routeData8.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-cotinine-cot-rapid-test') {
				let routeData9 = that.$router.resolve({name: "cordx-tyfast-cotinine-cot-rapid-test" });
				window.open(routeData9.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-fsh-rapid-test') {
				let routeData10 = that.$router.resolve({name: "cordx-tyfast-fsh-rapid-test" });
				window.open(routeData10.href, '_blank');
			}else if(value.custom == 'cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc') {
				let routeData11 = that.$router.resolve({name: "cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc" });
				window.open(routeData11.href, '_blank');
			}else {
				let routeData6 = that.$router.resolve({name: "Productsinfo", params: { productInfoId: value.custom } });
				window.open(routeData6.href, '_blank');
			}
		},
		//点击进入id=7的产品
		goProduct7() {
			let that = this;
			// let routeData = that.$router.resolve({name: "Productsinfo", params: { productInfoId: 'cordx-covid-19-ag-test' } });
			// window.open(routeData.href, '_blank');
			// window.open('https://pages.cordx.com/free-sample-kit');
			that.$router.push({ path: '/free-sample-kit', });
		},
		//产品列表分页
		productPageChange(val) {
			let that = this;
			that.noPage1 = val;
			that.getProductList();
		},
		//请求产品列表
		getProductList() {
			let that = this;
			that.productLoading = true;
			productList({
				custom: that.cateIds.join(','),
				cert_id: that.authIds.join(','),
				test_id: that.nowTest == 'All' ? '' : that.nowTest,
				page: that.noPage1,
				page_size: 6,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.productData = res.data.data;
				that.productPage = res.data.total;
				that.productLoading = false;
			});
		},
		//请求产品分类
		getProductCate(id) {
			let that = this;
			productCate({
				id: id,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.cateName = res.data[0].catname;
			});
		},
		//产品认证搜索
		rzInput() {
			this.authIds = [];
			this.getProductAuth();
		},
		//请求产品认证
		getProductAuth() {
			let that = this;
			productAuth({
				keyword: that.rzVal,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.rzOptions = res.data;
				//请求产品列表
				that.noPage1 = 1;
				that.getProductList();
			});
		},
		//请求产品分类2
		getProductCates(id) {
			let that = this;
			that.cateLoading = true;
			that.cateIds = [];
			productCates({
				custom: id,
				language: sessionStorage.getItem('lang'),
			}).then(res => {
				that.cateOptions = res.data;
				that.cateLoading = false;
				that.cateOptions.forEach((value, index) => {
					if(value.is_checked == 1) {
						that.cateIds.push(value.custom);
						that.cateName = value.catname;
					}
				});
				that.noPage1 = 1;
				that.nowTest = 'All';
				that.getProductList();
				that.getProductTest();
			});
		},
		//产品分类点击
		cateHandle(val) {
			let that = this;
			let dataArray = that.cateOptions;
			if(val.level == 1) {
				dataArray.forEach((value, index) => {
					if(value.id == val.id) {
						if(value.is_checked == 0) {
							that.getProductCates(val.custom);
						}else {
							that.getProductCates('');
						}
					}
				});
			}else {
				that.cateIds = [];
				dataArray.forEach((value, index) => {
					dataArray[index].is_checked = 0;
					value.children.forEach((value1, index1) => {
						if(value1.id == val.id) {
							if(value1.is_checked == 0) {
								dataArray[index].children[index1].is_checked = 1;
								that.cateIds.push(val.custom);
							}else {
								dataArray[index].children[index1].is_checked = 0;
							}
						}else {
							dataArray[index].children[index1].is_checked = 0;
						}
					});
				});
				that.noPage1 = 1;
				that.nowTest = 'All';
				that.getProductList();
				that.getProductTest();
			}
		},
		//产品认证点击
		authHandle(type, val) {
			let that = this;
			let dataArray = that.rzOptions;
			dataArray.forEach((value, index) => {
				if(value.id == val.id) {
					if(value.is_checked == 0) {
						dataArray[index].is_checked = 1;
					}else {
						dataArray[index].is_checked = 0;
					}
				}
				value.children.forEach((value1, index1) => {
					if(value1.id == val.id) {
						if(value1.is_checked == 0) {
							dataArray[index].children[index1].is_checked = 1;
						}else {
							dataArray[index].children[index1].is_checked = 0;
						}
					}
				});
			});
			that.rzOptions = dataArray;
			let arr1 = [];
			let arr2 = [];
			let arr = [];
			that.rzOptions.forEach((value, index) => {
				if(value.is_checked == 1) {
					arr1.push(value.id);
				}
				value.children.forEach((value1, index1) => {
					if(value1.is_checked == 1) {
						arr2.push(value1.id);
					}
				});
			});
			that.authIds = [...arr1, ...arr2];
			that.noPage1 = 1;
			that.getProductList();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*引导块*/
	.tips_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 80px;
		font-size: 16px;
		span{
			color: #0B318F;
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding: 80px 0 100px 0;
		.right{
			flex: 1;
			padding-left: 22px;
			position: relative;
			.search_list{
				position: absolute;
				top: 65px;
				left: 30px;
				width: 96%;
				padding: 20px 0px 0px 0px;
				background-color: #ffffff;
				box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				z-index: 1;
				.search_list_main{
					.search_el:hover{
						background-color: #F9FAFE;
					}
					.search_el{
						display: flex;
						align-items: center;
						padding: 30px 20px;
						cursor: pointer;
						border-bottom: 1px solid #EFEFEF;
						.search_el_right{
							flex: 1;
							padding-left: 30px;
							.title{
								padding-bottom: 8px;
								font-size: 16px;
								color: #0B318F;
							}
							.text{
								font-size: 14px;
								color: #0B318F;
							}
						}
						.search_el_left{
							width: 130px;
							img{ width: 100%; }
						}
					}
				}
				.top_box{
					display: flex;
					padding: 0px 20px 0px 20px;
					.top_box_left{
						flex: 1;
						font-size: 16px;
					}
					.top_box_right{
						width: auto;
					}
				}
			}
			.page_box{
				padding-top: 30px;
				text-align: center;
			}
			.tags{
				padding: 15px 0 0px 8px;
				div{
					display: inline-block;
					margin-right: 20px;
					margin-bottom: 15px;
					background: #FFFFFF;
					border-radius: 22px;
					border: 1px solid #0B318F;
					font-size: 16px;
					color: #0B318F;
					padding: 4px 16px 2px 16px;
					cursor: pointer;
				}
				div.actived{
					background-color: #0B318F;
					border: 1px solid #0B318F;
					color: #ffffff;
				}
			}
			.product_main{
				height: 1000px;
				overflow: auto;
				.product_list{
					.product_el:hover{
						.icon{
							transform: translateX(6px);
						}
					}
					.product_el{
						display: inline-block;
						width: 48%;
						height: 500px;
						margin: 12px 1%;
						background-color: #F8FAFF;
						border: 1px solid #eaeaea;
						overflow: hidden;
						cursor: pointer;
						.txt{
							padding: 0 15px;
							font-size: 18px;
							color: #706B69;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 3;
							overflow: hidden;
							text-overflow: ellipsis;
						}
						.tit_box{
							display: flex;
							padding: 30px 15px 20px 15px;
							.tit{
								flex: 1;
								padding-right: 10px;
								font-size: 22px;
								line-height: 1.5;
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 3;
								overflow: hidden;
								text-overflow: ellipsis;
							}
							.icon{
								width: 20px;
								margin-top: 10px;
								transition: all 0.3s;
								img{
									width: 100%;
								}
							}
						}
						.bg_box{
							background-color: #ffffff;
							.bg{
								width: 100%;
								height: 250px;
								object-fit: contain;
							}
						}
					}
				}
			}
			.input_box{
				padding-bottom: 12px;
				padding-left: 8px;
				.btn_box{
					width: 7%;
					margin-left: 3%;
					padding: 4px 20px;
					border-radius: 18px;
					background-color: #0066D4;
					display: inline-block;
					cursor: pointer;
				}
				input{
					width: 90%;
					height: 45px;
					line-height: 45px;
					border: 1px solid #EFEFEF;
					background-color: #ffffff;
					text-indent: 20px;
					font-size: 16px;
					color: #0B318F;
				}
				input:focus{
					outline: none;
					border: 2px solid #0066D4;
				}
			}
		}
		.left{
			width: 285px;
			.cate_box{
				padding: 24px 26px;
				background-color: #EFEFEF;
				.search_box{
					padding: 10px 0 15px 0;
					input{
						width: 100%;
						height: 45px;
						line-height: 45px;
						background-color: #ffffff;
						color: #000000;
						padding-left: 20px;
						border: 1px solid #999999;
					}
				}
				.list_height{
					// height: 300px;
					// overflow-y: scroll;
				}
				.list_box{
					.list_el{
						padding: 10px 0;
						.list_el_child{
							padding: 10px 0 0 20px;
						}
						.list_el_main{
							font-size: 18px;
							cursor: pointer;
							display: flex;
							.right{
								flex: 1;
								padding-left: 8px;
								line-height: 1.2;
							}
							.left{
								width: 16px;
								img{
									width: 100%;
								}
							}
						}
					}
				}
				.tit{
					padding-bottom: 15px;
					font-size: 21px;
					font-weight: bold;
				}
			}
		}
	}
	/*块1*/
	.block_1{
		width: 100%;
		padding: 40px 0;
		background-color: #0B318F;
		.block_1_box{
			width: 1140px;
			margin: 0 auto;
			.btn_box{
				margin-left: 45%;
			}
			.tit{
				padding-bottom: 30px;
				font-size: 24px;
				color: #ffffff;
				text-align: center;
			}
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_0{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 20px 0 20px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 55px;
		}
		.txt{
			font-size: 26px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #F5F8FA;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
<style scoped>
>>> .search_list .van-pagination__page-desc{
	display: none;
}
>>> .page_box .el-pager li:hover, >>> .page_box .el-pager li.active{
	color: #0B318F;
}
</style>
